import React from "react";
import PageHeader, { LegalBody } from "../components/PageHeader";
import { COMPANY } from "../mock/data";

export default function Refund() {
  return (
    <>
      <PageHeader eyebrow="Legal" title="Refund & Cancellation Policy" subtitle="30-day money-back guarantee on all paid plans." />
      <LegalBody>
        <p className="text-sm text-slate-500">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>

        <h2>1. 30-Day Money-Back Guarantee</h2>
        <p>If you are not completely satisfied with your {COMPANY.brand} paid subscription, you may request a full refund within thirty (30) days of the original purchase date. No questions asked.</p>

        <h2>2. How to Request a Refund</h2>
        <ul>
          <li>Email <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a> with the subject line &ldquo;Refund Request”.</li>
          <li>Include your order ID, registered email address, and reason for the refund (optional).</li>
          <li>Alternatively, call our support team at <a href={`tel:${COMPANY.phoneRaw}`}>{COMPANY.phone}</a>.</li>
        </ul>

        <h2>3. Processing Time</h2>
        <p>Approved refunds are processed within 5–7 business days back to the original payment method. Depending on your bank or card issuer, it may take an additional 3–10 business days for the amount to reflect in your statement.</p>

        <h2>4. Cancellation of Subscription</h2>
        <p>You can cancel your subscription at any time by contacting support or through your account. Upon cancellation, your subscription will remain active until the end of the current billing period, after which it will not be renewed.</p>

        <h2>5. Non-Refundable Situations</h2>
        <ul>
          <li>Refund requests submitted after 30 days from the original purchase date.</li>
          <li>Renewals — you may cancel before the next renewal cycle to avoid charges.</li>
          <li>Accounts terminated for violation of our Terms of Service.</li>
        </ul>

        <h2>6. Chargebacks</h2>
        <p>If you initiate a chargeback with your card issuer without first contacting us, we reserve the right to suspend your account. We encourage you to contact us first so we can resolve any issue quickly.</p>

        <h2>7. Contact</h2>
        <p>
          {COMPANY.legalName}<br />
          Email: <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a><br />
          Phone: <a href={`tel:${COMPANY.phoneRaw}`}>{COMPANY.phone}</a>
        </p>
      </LegalBody>
    </>
  );
}
